<template>
  <footer class="footer" style="height: 200px; padding: 20px 100px; background: #061130; color: white">
    <div class="container-fluid">
      <nav class="pull-left">
        <ul>
          <li>
            <a href="https://www.fnmotol.cz/">
              O aplikaci
            </a>
          </li>
          <li>
            <a href="https://www.fnmotol.cz/">
              Kontakty
            </a>
          </li>
          <li>
            <a href="https://www.fnmotol.cz/">
              Novinky
            </a>
          </li>
        </ul>
      </nav>

      <a aria-label="logo" href="https://www.bioxsys.cz/">
        <div class="logo-img" style="float: right;">
          <img src="/img/bioxsys_negative.svg" alt="">
        </div>
      </a>

      <div class="copyright" style="float: bottom; margin: 10px 30px 20px 0;">
          Copyright &copy;
          Bioxsys s.r.o., 2019 - {{year}} . All rights reserved
      </div>
    </div>





  </footer>
</template>
<script>
  export default {
    data() {
      return {
        year: "",
      }
    },

    mounted () {
        var currentTime = new Date()
        this.year = currentTime.getFullYear();
    },

  }

</script>
<style>

</style>
